import { useEffect } from "react";
import { useUserDetails } from "./context/auth";

//Icons
import HomeIcon from "@mui/icons-material/Home";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import EditCalendarIcon from "@mui/icons-material/EditCalendar";
import {
  Assignment,
  BeachAccess,
  DeviceHubRounded,
  EventAvailable,
  Logout,
  SettingsSuggest,
} from "@mui/icons-material";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import BarChartIcon from "@mui/icons-material/BarChart";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import AirplanemodeActiveIcon from "@mui/icons-material/AirplanemodeActive";
import { IoRocketSharp } from "react-icons/io5";

//Pages
import Signin from "./pages/authentication/signin";
import Dashboard from "./pages/dashboard/index";
import HRDashboard from "./pages/dashboard/HR_dashboard";
import ManagerDashboard from "./pages/dashboard/Manger_dashboard";
import EmployeeManagement from "./pages/employeemanagement";
import AddEmployee from "./pages/employeemanagement/components/AddEmployee";
import ManagerManagement from "./pages/managermanagement";
import AddManager from "./pages/managermanagement/Components/AddManager";
import Department from "./pages/department";
import AddDepartment from "./pages/department/components/AddDepartment";
import Designation from "./pages/designation";
import AddDesignation from "./pages/designation/components/AddDesignation";
import Payroll from "./pages/payroll";
import LeaveManagement from "./pages/leavemanagement";
import AddLeaveRequest from "./pages/leavemanagement/components/AddLeaveRequest";
import RegularizationRequest from "./pages/regularizationrequest";
import AddRegularization from "./pages/regularizationrequest/components/AddRegularization";
import WFHManagemnt from "./pages/wfhmanagement";
import AddWFH from "./pages/wfhmanagement/components/AddWFH";
import Attendance from "./pages/attendance";
import Callender from "./pages/callender";
import ManuallyAddedCandidate from "../src/pages/ManuallyaddedCandidate/index";
import AddManualLop from "../src/pages/ManualLop/Component/AddManualLop";
import ComponentManagement from "./pages/mastercomponent";
import TaskAllocation from "./pages/TaskAllocation";
import AllocateTask from "./pages/TaskAllocation/Component";
import AddSalaryStructure from "./pages/salarystructure/components/AddSalaryStructure";
import SalaryStructure from "./pages/salarystructure";
import AddComponent from "./pages/mastercomponent/components/AddComponent";
import WeekOff from "./pages/weekoff";
import AddWeekOff from "./pages/weekoff/components";
import EmployeeSalary from "./pages/employeesalary";
import AddEmployeeSalary from "./pages/employeesalary/components/AddSalaryStructure";
import Holiday from "./pages/holiday";
import AddHoliday from "./pages/holiday/components/AddHoliday";
import AddPayroll from "./pages/payroll/components/AddSalaryStructure";
import AddPerformance from "./pages/performance/components/AddPerformance";
import Shift from "./pages/shift";
import AddShift from "./pages/shift/components/AddShift";
import ViewScreen from "./pages/employeemanagement/components/AddEmployee/components/ViewScreen";
import Weekoff_viewscreen from "./pages/weekoff/ViewScreen/index";
import Shift_viewscreen from "./pages/shift/Viewscreen";
import OTMaster from "./pages/OT_Master";
import AddOT from "./pages/OT_Master/Component";
import LeaveConfiguration from "./pages/LeaveConfiguration/LeaveConfiguration";
import Addleaveconfiguration from "./pages/LeaveConfiguration/LeaveConfiguration/Component";
import ViewScreen_LeaveData from "./pages/leavemanagement/ViewScreen";
import Role_Permit from "./pages/Role_Permission";
import Rollcreation from "./pages/Rolecreate/component";
import Rolecreatelist from "./pages/Rolecreate";
import RegularzationApproval from "./pages/regularizationrequest/ViewScreen";
import WFHApproval from "./pages/wfhmanagement/ViewScreen";
import WFHViewScreen from "./pages/wfhmanagement/ViewScreen/View_index";
import ViewScreenRegularzation from "./pages/regularizationrequest/ViewScreen/Regularzise_View";
import LeaveApproval from "./pages/leavemanagement/ViewScreen/LeaveApproval";
import AddPayslip from "./pages/Payslip";
import Newstaff from "./newonboardfolder/createStaffrequesst2";
import StaffRequestTable from "./newonboardfolder/staffrequesttable";
import SourceProfile from "./newonboardfolder/sourceprofile";
import ScreeningTable from "./newonboardfolder/ScreeningTable";
import Screening from "./newonboardfolder/screening";
import TechiInterviewTable from "./newonboardfolder/technicalinterviewtable";
import RecrruitmentTable from "./newonboardfolder/RecruitmentTable";
import Sourcing from "./newonboardfolder/Sourcing";
import ApprovalScreen from "./newonboardfolder/ApprovalScreen";
import Procedure from "./newonboardfolder/Procedure";
import Reports from "./newonboardfolder/Report";
import Permission from "./pages/Permission";
import PermissionTable from "./pages/Permissiontable";
import PermissionApproval from "./pages/PermissionApproval";
import PerformanceEvaluation from "./pages/performanceEvaluation/PerformanceEvaluation";
import PerfomanceEvaluationForm from "./pages/performanceEvaluation/PerfomanceEvaluationForm";
import ViewScreen_Premission from "./pages/Permission/ViewScreen";
import EmpCategory from "./pages/employeemanagement/components/EmployeeCategory/EmpCategory";
import Status from "./pages/Workflow/Component/Status";
import Action from "./pages/Workflow/Component/Action";
import Levelofworkflow from "./pages/Workflow/Component/Levelofworkflow";
import WorkflowApprover from "./pages/Workflow/Component/WorkflowApprover";
import ApprovalWorkFlowManagement from "./pages/approvalworkflow";
import AddWorkflow from "./pages/approvalworkflow/addworkflow";
import OnsiteTabel from "./pages/onsite/OnsiteTabel";
import OnsiteForm from "./pages/onsite/OnsiteForm";
import ResignationTabel from "./pages/exitForm/resignation/resignationTable";
import ResignationForm from "./pages/exitForm/resignation/resignationForm";
import ResignationApproval from "./pages/exitForm/resignation/approvalForm";
import AddExitForm from "./pages/exitForm/exit/exitForm";
import ExitFormList from "./pages/exitForm/exit";
import AddComplaintForm from "./pages/hrdesk/complaintform/AddComplaintForm";
import AddLeavecalrificationForm from "./pages/hrdesk/leaveclarification/Addleaveclarification";
import AddAssessmentCreation from "./pages/learningManagement/AssesmentCreation/AddAssessment/addassessment";
import UpdateCourseMaterial from "./pages/learningManagement/CourseMaterial/Addorupdate";
import AssessmentPage from "./pages/learningManagement/AssesmentCreation/AttendAssessment";
import CourseAssessment from "./pages/learningManagement/AssesmentCreation/AttendAssessment/CourseAssessment";
import { components } from "react-select";
import CourseMaterial from "./pages/learningManagement/CourseMaterial/List";
import CongratsPage from "./pages/learningManagement/AssesmentCreation/AttendAssessment/CongratsPage";
import AddCandidate from "../src/pages/ManuallyaddedCandidate/Components/index";
import PolicyList from "./pages/policy_comp/policyview";
import AddPolicy from "./pages/policy_comp/policyadd";
import PolicyIcon from "@mui/icons-material/Policy";
import AddCompany from "./pages/CompanyMaster";
import Allbranches from "./pages/BranchMaster/listbranch";
import AddBranch from "./pages/BranchMaster";
import Tax from "./pages/Tax";
import AddTax from "./pages/Tax/AddTax";
import EmojiTransportationIcon from "@mui/icons-material/EmojiTransportation";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import assestsConfig from "./config/assestsConfig";
import AuthLoader from "./pages/AuthLoader";
import OrganizationStructure from "./pages/Organizationstructure";
import ProfesionalTax from "./pages/Professional Tax";
import FullHierarchyTreeEnhanced from "./pages/Organizationstructure/treeview";
import OrgChart from "./pages/Organizationstructure/treeview";
import Chart from "./pages/Organizationstructure/treeview";
import PolicyManagementList from "./pages/policyManagement/PolicyManagementList";
import OfferLetterList from "./pages/offerLetter";
import AppointmentLetterList from "./pages/appointmentLetter";
import OfferLetterForm from "./pages/offerLetter/components/OfferLetterForm";
import OfferPDF from "./pages/offerLetter/components/OfferPdf";
import AppointmentLetterForm from "./pages/appointmentLetter/components/AppointmentLetterForm";
import AppointmentPdf from "./pages/appointmentLetter/components/AppointmentPdf";
import Calendar from "./pages/calendar";
import LeaveCount from "./pages/leaveCount";

function Routes_Data() {
  const { setroutesdata, AccessData } = useUserDetails();

  //  console.log("assestsConfig.company",assestsConfig.company, AccessData)

  const routes = [
    {
      name: "Authentication",
      key: "authentication",
      collapse: [
        {
          name: "Sign in",
          key: "sign-in",
          route: "/sign-in",
          component: <Signin />,
        },
        {
          name: "Sign in",
          key: "sign-in",
          route: "/authentication",
          component: <AuthLoader />,
        },
      ],
    },
    ...(AccessData &&
    Array.isArray(AccessData) &&
    AccessData.some(
      (item) => item.component === "EmployeeDashboard" && item.can_access,
    )
      ? [
          {
            type: "collapse",
            icon: <HomeIcon />,
            name: "DashBoard",
            key: "dashboard",
            route: "/dashboard",
            component: <Dashboard />,
            noCollapse: true,
            permissions: {
              authenticated: true,
              roles: ["all"],
            },
          },
        ]
      : []),

    ...(AccessData &&
    Array.isArray(AccessData) &&
    AccessData.some(
      (item) => item.component === "ManagerDashboard" && item.can_access,
    )
      ? [
          {
            type: "collapse",
            icon: <HomeIcon />,
            name: "DashBoard",
            key: "dashboard",
            route: "/dashboard",
            component: <ManagerDashboard />,
            noCollapse: true,
            permissions: {
              authenticated: true,
              roles: ["all"],
            },
          },
        ]
      : []),

    ...(AccessData &&
    Array.isArray(AccessData) &&
    AccessData.some(
      (item) => item.component === "HrDashboard" && item.can_access,
    )
      ? [
          {
            type: "collapse",
            icon: <HomeIcon />,
            name: "DashBoard",
            key: "dashboard",
            route: "/dashboard",
            component: <HRDashboard />,
            noCollapse: true,
            permissions: {
              authenticated: true,
              roles: ["all"],
            },
          },
        ]
      : []),

    // Eg Reuirement
    ...(assestsConfig.company === "Eg"
      ? [
          ...(AccessData?.some((item) => item.module === "Company")
            ? [
                {
                  type: "collapse",
                  icon: <EmojiTransportationIcon />,
                  name: "My Company",
                  key: "my-company",
                  route: "/company",
                  component: <AddCompany />,
                  noCollapse: true,
                  protected: true,
                  permissions: { authenticated: true, roles: ["all"] },
                },
              ]
            : []),

          ...(AccessData?.some((item) => item.module === "Branch")
            ? [
                {
                  type: "collapse",
                  icon: <CorporateFareIcon />,
                  name: "My Branch",
                  key: "my-branch",
                  route: "/branch",
                  component: <Allbranches />,
                  noCollapse: true,
                  protected: true,
                  permissions: { authenticated: true, roles: ["all"] },
                },
              ]
            : []),

          ...(AccessData?.some(
            (item) => item.component === "AddBranch" && item.can_access,
          )
            ? [
                {
                  name: "Add Branch",
                  key: "add-branch",
                  route: "/branch/add-branch",
                  component: <AddBranch />,
                  noCollapse: true,
                  protected: true,
                  permissions: { authenticated: true, roles: ["all"] },
                },
              ]
            : []),
        ]
      : []),
    //Eg Requirement
    ...(AccessData &&
    Array.isArray(AccessData) &&
    AccessData.some(
      (item) =>
        item.module === "EmployeeManagement" ||
        item.module === "ManagerManagement" ||
        item.module === "Department" ||
        item.module === "Designation",
    )
      ? [
          {
            type: "collapse",
            name: "Master",
            key: "Master",
            icon: <ManageAccountsIcon size="12px" />,
            collapse: [
              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) => item.module === "Role" && item.can_access,
              )
                ? [
                    {
                      name: "Role Creation",
                      key: "role-List",
                      route: "/role-List",
                      component: <Rolecreatelist />,
                    },
                  ]
                : []),
              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) =>
                  (item.module === "EmployeeManagement" && item.can_access) ||
                  item.module === "Leave Configuration" ||
                  item.module === "Shift" ||
                  item.module === "OTMaster",
              )
                ? [
                    {
                      name: "Employee Management",
                      key: "employee-management",
                      route: "/employee-management",
                      component: <EmployeeManagement />,
                    },
                  ]
                : []),
              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) =>
                  item.module === "ManagerManagement" && item.can_access,
              )
                ? [
                    {
                      name: "Manager Management",
                      key: "manager-management",
                      route: "/manager-management",
                      component: <ManagerManagement />,
                    },
                  ]
                : []),
              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) => item.module === "Department" && item.can_access,
              )
                ? [
                    {
                      name: "Department",
                      key: "department",
                      route: "/department",
                      component: <Department />,
                    },
                  ]
                : []),
              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) => item.module === "Designation" && item.can_access,
              )
                ? [
                    {
                      name: "Designation",
                      key: "designation",
                      route: "/designation",
                      component: <Designation />,
                    },
                  ]
                : []),

              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) => item.module === "Shift" && item.can_access,
              )
                ? [
                    {
                      name: "Shift",
                      key: "shift",
                      route: "/shift",
                      component: <Shift />,
                    },
                  ]
                : []),
              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) => item.module === "OTMaster" && item.can_access,
              )
                ? [
                    {
                      name: "OT Master",
                      key: "ot_master",
                      route: "/OTMaster",
                      component: <OTMaster />,
                    },
                  ]
                : []),
            ],
          },
        ]
      : []),
    {
      type: "noCollapse",
      key: "addcategory",
      route: "/employee-category/add-employee-category",
      component: <EmpCategory />,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "status",
      route: "/Workflow-manager/Workflow-Status",
      component: <Status />,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "actions",
      route: "/Workflow-manager/Workflow-Actions",
      component: <Action />,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "levelofworkflow",
      route: "/Workflow-manager/Level-of-workflow",
      component: <Levelofworkflow />,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "levelofworkflow",
      route: "/Workflow-manager/Workflow-Approver",
      component: <WorkflowApprover />,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },

    {
      type: "noCollapse",
      key: "status",
      route: "/Workflow-manager/Status",
      component: <Status />,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "actions",
      route: "/Workflow-manager/Actions",
      component: <Action />,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    ...(AccessData &&
    Array.isArray(AccessData) &&
    AccessData.some(
      (item) =>
        item.module === "Staff Request" ||
        item.module === "Sourcing" ||
        item.module === "Technical Feedback" ||
        item.module === "Requirement" ||
        item.module === "OfferLetter" ||
        item.module === "AppointmentLetter",
    )
      ? [
          {
            type: "collapse",
            name: "Recruitment",
            key: "recruirement",
            icon: <PersonSearchIcon size="12px" />,
            collapse: [
              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) => item.module === "Staff Request" && item.can_access,
              )
                ? [
                    {
                      name: "Staff Request",
                      key: "staff-request",
                      route: "/staff-request",
                      component: <StaffRequestTable />,
                    },
                  ]
                : []),
              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) => item.module === "Sourcing" && item.can_access,
              )
                ? [
                    {
                      name: "Sourcing & Screening",
                      key: "sourcing-screening",
                      route: "/sourcing",
                      component: <ScreeningTable />,
                    },
                  ]
                : []),
              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) =>
                  item.module === "Technical Feedback" && item.can_access,
              )
                ? [
                    {
                      name: "Technical & Feedback",
                      key: "technical-feedback",
                      route: "/technical",
                      component: <TechiInterviewTable />,
                    },
                  ]
                : []),
              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) => item.module === "Requirement" && item.can_access,
              )
                ? [
                    {
                      name: "Recruitment",
                      key: "recruitment",
                      route: "/recruitment",
                      component: <RecrruitmentTable />,
                    },
                  ]
                : []),
              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) => item.module === "OfferLetter" && item.can_access,
              )
                ? [
                    {
                      name: "Offer Letter",
                      key: "offer-letter",
                      route: "/offer-letter",
                      component: <OfferLetterList />,
                    },
                  ]
                : []),
              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) =>
                  item.module === "AppointmentLetter" && item.can_access,
              )
                ? [
                    {
                      name: "Appointment Letter",
                      key: "appointment-letter",
                      route: "/appointment-letter",
                      component: <AppointmentLetterList />,
                    },
                  ]
                : []),
            ],
          },
        ]
      : []),

    ...(AccessData &&
    Array.isArray(AccessData) &&
    AccessData.some(
      (item) => item.module === "Procedure" || item.module === "Reports",
    )
      ? [
          {
            type: "collapse",
            name: "Onboarding",
            key: "Onboarding",
            icon: <IoRocketSharp size="15px" />,
            collapse: [
              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) => item.module === "Procedure" && item.can_access,
              )
                ? [
                    {
                      name: "Procedure",
                      key: "recruitment",
                      route: "/Procedure",
                      component: <Procedure />,
                    },
                  ]
                : []),
              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) => item.module === "Reports" && item.can_access,
              )
                ? [
                    {
                      name: "Reports",
                      key: "reports",
                      route: "/Reports",
                      component: <Reports />,
                    },
                  ]
                : []),
            ],
          },
        ]
      : []),
    {
      type: "noCollapse",
      key: "onboarding-employee-details",
      route: "/staff-request/create-Staffrequest",
      component: <Newstaff />,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "onboarding-employee-details",
      route: "/staff-request/approval-screen",
      component: <ApprovalScreen />,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "sourcing",
      route: "/sourcing/create-Sourcing",
      component: <Sourcing />,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "screening",
      route: "/sourcing/createscreening",
      component: <Screening />,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "feedback",
      route: "/technical/feedback",
      component: <SourceProfile />,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "offer-Letter-Form",
      route: "/offer-letter/offer-Letter-Form",
      component: <OfferLetterForm />,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "offer-Letter-Pdf",
      route: "/offer-letter/offer-pdf",
      component: <OfferPDF />,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "appointment-Letter-Form",
      route: "/appointment-letter/appointment-Letter-Form",
      component: <AppointmentLetterForm />,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "appointment-Letter-Pdf",
      route: "/appointment-letter/appointment-pdf",
      component: <AppointmentPdf />,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "add-employee",
      route: "/employee-management/add-employee",
      component: <AddEmployee />,

      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "add-employee",
      route: "/employee-management/viewscreen",
      component: <ViewScreen />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      name: "noCollapse",
      key: "role-Form",
      route: "/role-List/role-Form",
      component: <Rollcreation />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "add-employee",
      route: "/apply-leave/viewscreen",
      component: <ViewScreen_LeaveData />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "employee-details",
      route: "/employee-management/employee-details",
      component: <AddEmployee />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "add-manager",
      route: "/manager-management/add-manager",
      component: <AddManager />,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "manager-details",
      route: "/manager-management/manager-details",
      // route: "/manager-management/manager-details/:id",
      component: <AddManager />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "add-department",
      route: "/department/add-department",
      component: <AddDepartment />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "department-details",
      route: "/department/department-details",
      component: <AddDepartment />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "add-designation",
      route: "/designation/add-designation",
      component: <AddDesignation />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "designation-details",
      route: "/designation/designation-details",
      component: <AddDesignation />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },

    {
      type: "noCollapse",
      key: "complaintForm-details",
      route: "/complaintForm/complaintForm-details",
      component: <AddComplaintForm />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "AddComponent",
      key: "add-component",
      route: "/component/add-component",
      component: <AddComponent />,
      protected: true,
    },
    {
      type: "salaryStructure",
      key: "salary-structure",
      route: "/salary-structure/add-salary-structure",
      component: <AddSalaryStructure />,
      protected: true,
    },
    {
      type: "employeeSalary",
      key: "employee-salary",
      route: "/employee-salary/add-employee-salary",
      component: <AddEmployeeSalary />,
      protected: true,
    },
    ...(AccessData &&
    Array.isArray(AccessData) &&
    AccessData.some(
      (item) => item.module === "Role" || item.module === "Role Permission",
    )
      ? [
          {
            type: "collapse",
            name: "Configuration",
            key: "configuration",
            icon: <SettingsSuggest size="12px" />,
            collapse: [
              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) => item.module === "Role Permission" && item.can_access,
              )
                ? [
                    {
                      name: "Role Permission",
                      key: "rolepermission",
                      route: "/rolepermission",
                      component: <Role_Permit />,
                    },
                  ]
                : []),
              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) =>
                  item.module === "LeaveConfiguration" && item.can_access,
              )
                ? [
                    {
                      name: "Leave Configuration",
                      key: "leave-configuration",
                      route: "/leave-configuration",
                      component: <LeaveConfiguration />,
                    },
                  ]
                : []),
              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some((item) => item.module === "EmployeeManagement")
                ? [
                    {
                      type: "collapse",
                      icon: <DeviceHubRounded />,
                      name: "Manage Workflow",
                      key: "Manage-Workflow",
                      route: "/approval",
                      component: <ApprovalWorkFlowManagement />,
                      noCollapse: true,
                      protected: true,
                      permissions: {
                        authenticated: true,
                        roles: ["all"],
                      },
                    },
                  ]
                : []),
            ],
          },
        ]
      : []),

    ...(AccessData &&
    Array.isArray(AccessData) &&
    AccessData.some(
      (item) =>
        item.module === "ApplyLeave" ||
        item.module === "RegularaizationRequest" ||
        item.module === "WFHManagement" ||
        item.module === "WeekOff" ||
        item.module === "Holiday" ||
        item.module === "Permission",
    )
      ? [
          {
            type: "collapse",
            name: "Leave Management",
            key: "leave-management",
            icon: <CalendarMonthIcon size="12px" />,
            collapse: [
              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) => item.module === "LeaveCount" && item.can_access,
              )
                ? [
                    {
                      name: "Leave Count",
                      key: "leave-count",
                      route: "/leave-count",
                      component: <LeaveCount />,
                    },
                  ]
                : []),
              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) => item.module === "ApplyLeave" && item.can_access,
              )
                ? [
                    {
                      name: "Apply Leave",
                      key: "apply-leave",
                      route: "/apply-leave",
                      component: <LeaveManagement />,
                    },
                  ]
                : []),

              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) => item.module === "ManualLop" && item.can_access,
              )
                ? [
                    {
                      name: "Manual Lop",
                      key: "manual-lop",
                      route: "/manual-lop",
                      // component: <ManualLop />,
                      component: <AddManualLop />,
                    },
                  ]
                : []),

              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) =>
                  item.module === "RegularaizationRequest" && item.can_access,
              )
                ? [
                    {
                      name: "Regularization Request",
                      key: "regularization-request",
                      route: "/regularization-request",
                      component: <RegularizationRequest />,
                    },
                  ]
                : []),
              {
                name: "WFH Management",
                key: "WFH-Management",
                route: "/WFH-Management",
                component: <WFHManagemnt />,
              },
              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) => item.module === "Permission" && item.can_access,
              )
                ? [
                    {
                      name: "Permission",
                      key: "permission",
                      route: "/permission",
                      component: <PermissionTable />,
                    },
                  ]
                : []),
            ],
          },
        ]
      : []),

    ...(AccessData &&
    Array.isArray(AccessData) &&
    AccessData.some(
      (item) => item.module === "Attendance" || item.module === "Calendar",
    )
      ? [
          {
            type: "collapse",
            name: "Calendar",
            key: "calsendar",
            icon: <EditCalendarIcon size="12px" />,
            collapse: [
              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) => item.module === "Attendance" && item.can_access,
              )
                ? [
                    {
                      name: "Attendance",
                      key: "attendance",
                      route: "/attendance",
                      component: <Attendance />,
                    },
                  ]
                : []),
              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) => item.module === "Calendar" && item.can_access,
              )
                ? [
                    {
                      name: "Calendar",
                      key: "Calendar",
                      route: "/calendar",
                      // component: <Callender />,
                      component: <Calendar />,
                    },
                  ]
                : []),
            ],
          },
        ]
      : []),

    ...(AccessData &&
    Array.isArray(AccessData) &&
    AccessData.some(
      (item) =>
        item.module === "Component" ||
        item.module === "EmployeeSalary" ||
        item.module === "SalaryStructure" ||
        item.module === "Payroll" ||
        item.module === "Payslip",
    )
      ? [
          {
            type: "collapse",
            name: "Pay Roll",
            key: "pay-roll",
            icon: <AccountBalanceWalletIcon size="12px" />,
            collapse: [
              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) =>
                  item.module === "TaxConfiguration" &&
                  item.component === "ListTax" &&
                  item.can_access,
              )
                ? [
                    {
                      name: "Tax Configuration",
                      key: "tax",
                      route: "/tax",
                      component: <Tax />,
                    },
                  ]
                : []),

              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) =>
                  item.module === "ProfesionalTax" &&
                  item.component === "ListPT" &&
                  item.can_access,
              )
                ? [
                    {
                      name: "Professional Tax",
                      key: "profesionaltax",
                      route: "/professional-taxconfig",
                      component: <ProfesionalTax />,
                    },
                  ]
                : []),
              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) => item.module === "Component" && item.can_access,
              )
                ? [
                    {
                      name: "Component",
                      key: "component",
                      route: "/component",
                      component: <ComponentManagement />,
                    },
                  ]
                : []),

              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) => item.module === "SalaryStructure" && item.can_access,
              )
                ? [
                    {
                      name: "Salary Structure",
                      key: "salary-structure",
                      route: "/salary-structure",
                      component: <SalaryStructure />,
                    },
                  ]
                : []),
              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) => item.module === "EmployeeSalary" && item.can_access,
              )
                ? [
                    {
                      name: "Employee Salary",
                      key: "employee-salary",
                      route: "/employee-salary",
                      component: <EmployeeSalary />,
                    },
                  ]
                : []),

              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) => item.module === "Payroll" && item.can_access,
              )
                ? [
                    {
                      name: "Pay Roll",
                      key: "pay-roll",
                      route: "/pay-roll",
                      component: <Payroll />,
                    },
                  ]
                : []),
              ...(AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) => item.module === "Payslip" && item.can_access,
              )
                ? [
                    {
                      name: "Pay Slip",
                      key: "pay-slip",
                      route: "/pay-slip",
                      component: <AddPayslip />,
                    },
                  ]
                : []),
            ],
          },
        ]
      : []),

    ...(AccessData &&
    Array.isArray(AccessData) &&
    AccessData.some(
      (item) =>
        item.module === "TaxConfiguration" &&
        item.component === "AddTax" &&
        item.can_access,
    )
      ? [
          {
            name: "noCollapse",
            key: "add-tax",
            route: "/tax/add-tax",
            component: <AddTax />,
            noCollapse: true,
            protected: true,
            permissions: {
              authenticated: true,
              roles: ["all"],
            },
          },
        ]
      : []),

    {
      name: "noCollapse",
      key: "add-candidate",
      route: "/recruitment/add-candidate",
      component: <AddCandidate />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },

    {
      name: "collapse",
      key: "payroll",
      route: "/pay-roll/add-payroll",
      component: <AddPayroll />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      name: "collapse",
      key: "add-OT",
      route: "/OTMaster/add-OT",
      component: <AddOT />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "onboarding-employee-details",
      route: "/permission/request-permission",
      component: <Permission />,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      name: "collapse",
      key: "add-leaveconfiguration",
      route: "/leave-configuration/add-leaveconfiguration",
      component: <Addleaveconfiguration />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },

    {
      name: "collapse",
      key: "add-leaverequest",
      route: "/apply-leave/apply-leaverequest",
      component: <AddLeaveRequest />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      name: "collapse",
      key: "add-leaverequest",
      route: "/apply-leave/leaveapproval",
      component: <LeaveApproval />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      name: "AddRegularization",
      key: "add-regularization",
      route: "/regularization-request/add-regularization",
      component: <AddRegularization />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },

    {
      type: "noCollapse",
      key: "regularization-details",
      route: "/regularization-request/regularization-details",
      component: <AddRegularization />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "regularization-details",
      route: "/regularization-request/RegularzationApproval",
      component: <RegularzationApproval />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "regularization-details",
      route: "/regularization-request/View-Regularization",
      component: <ViewScreenRegularzation />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "ViewScreen_Premission",
      route: "/permission/ViewScreen_Premission",
      component: <ViewScreen_Premission />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      name: "noCollapse",
      key: "add-wfh",
      route: "/WFH-Management/add-WFH",
      component: <AddWFH />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "wfh-details",
      route: "/WFH-Management/WFH-details",
      component: <AddWFH />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "wfh-details",
      route: "/WFH-Management/WFHApproval",
      component: <WFHApproval />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "wfh-details",
      route: "/WFH-Management/WFHViewScreen",
      component: <WFHViewScreen />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      name: "noCollapse",
      key: "add-weekoff",
      route: "/weekoff/add-weekoff",
      component: <AddWeekOff />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      name: "noCollapse",
      key: "add-weekoff",
      route: "/weekoff/Viewscreen",
      component: <Weekoff_viewscreen />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "weekoff-details",
      route: "/weekoff/weekoff-details",
      component: <AddWeekOff />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      name: "noCollapse",
      key: "add-shift",
      route: "/shift/add-shift",
      component: <AddShift />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "shift-details",
      route: "/shift/shift-details",
      component: <AddShift />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "shift-details",
      route: "/shift/Viewscreen",
      component: <Shift_viewscreen />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      name: "noCollapse",
      key: "add-holiday",
      route: "/holiday/add-holiday",
      component: <AddHoliday />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "holiday-details",
      route: "/holiday/holiday-details",
      component: <AddHoliday />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    ...(AccessData &&
    Array.isArray(AccessData) &&
    AccessData.some((item) => item.module === "Performance")
      ? [
          {
            type: "collapse",
            icon: <BarChartIcon />,
            name: "Performance Evaluation",
            key: "performance-evaluation",
            route: "/performance-evaluation",
            component: <PerformanceEvaluation />,
            noCollapse: true,
            protected: true,
            permissions: {
              authenticated: true,
              roles: ["all"],
            },
          },
        ]
      : []),

    ...(AccessData &&
    Array.isArray(AccessData) &&
    AccessData.some((item) => item.module === "WeekOff" && item.can_access)
      ? [
          {
            type: "collapse",
            icon: <EventAvailable />,
            name: "Week Off",
            key: "weekoff",
            route: "/weekoff",
            component: <WeekOff />,
            noCollapse: true,
            protected: true,
            permissions: {
              authenticated: true,
              roles: ["all"],
            },
          },
        ]
      : []),

    ...(AccessData &&
    Array.isArray(AccessData) &&
    AccessData.some((item) => item.module === "Holiday" && item.can_access)
      ? [
          {
            type: "collapse",
            icon: <BeachAccess />,
            name: "Holiday",
            key: "holiday",
            route: "/holiday",
            component: <Holiday />,
            noCollapse: true,
            protected: true,
            permissions: {
              authenticated: true,
              roles: ["all"],
            },
          },
        ]
      : []),

    // {
    //     type: "collapse",
    //     icon: <BarChartIcon />,
    //     name: "Organization Structure",
    //     key: "organization-structure",
    //     route: "/organization-structure",
    //      component: <OrganizationStructure />,
    //      // component: <Chart />,
    //     noCollapse: true,
    //     protected: true,
    //     permissions: {
    //       authenticated: true,
    //       roles: ["all"],
    //     },
    //   },

    //       {
    //   type: "collapse",
    //   icon: <BarChartIcon />,
    //   name: "Professional Tax Config",
    //   key: "professional-taxconfig",
    //   route: "/professional-taxconfig",
    //   component: <ProfesionalTax />,
    //   noCollapse: true,
    //   protected: true,
    //   permissions: {
    //     authenticated: true,
    //     roles: ["all"],
    //   },
    // },

    ...(AccessData &&
    Array.isArray(AccessData) &&
    AccessData.some(
      (item) =>
        item.module === "Staff Request" ||
        item.module === "Sourcing" ||
        item.module === "Technical Feedback" ||
        item.module === "Requirement",
    )
      ? [
          {
            type: "noCollapse",
            name: "ManuallyAddedCandidates",
            key: "manually-added-candidate",
            route: "/recruitment/manually-added-candidate",
            component: <ManuallyAddedCandidate />,
            noCollapse: true,
            protected: true,
            permissions: {
              authenticated: true,
              roles: ["all"],
            },
          },
        ]
      : []),

    ...(AccessData &&
    Array.isArray(AccessData) &&
    AccessData.some((item) => item.module === "TaskAllocation")
      ? [
          {
            type: "collapse",
            icon: <Assignment />,
            name: "Task Allocation",
            key: "task-allocation",
            route: "/task-allocation",
            component: <TaskAllocation />,
            noCollapse: true,
            protected: true,
            permissions: {
              authenticated: true,
              roles: ["all"],
            },
          },
        ]
      : []),
    {
      name: "noCollapse",
      key: "add-performance",
      route: "/performance/add-performance",
      component: <AddPerformance />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      name: "collapse",
      key: "add-leaverequest",
      route: "/task-allocation/add-task",
      component: <AllocateTask />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "performance-details",
      route: "/performance/performance-details",
      component: <AddPerformance />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },

    //  ...(AccessData &&
    // Array.isArray(AccessData) &&
    // AccessData.some((item) => item.module === "onsite")
    //   ? [
    //       {
    //         type: "collapse",
    //         icon: <PolicyIcon />,
    //         name: "Policy",
    //         key: "policy",
    //         route: "/policy",
    //         component: <PolicyList/>,
    //         noCollapse: true,
    //         protected: true,
    //         permissions: {
    //           authenticated: true,
    //           roles: ["all"],
    //         },
    //       },
    //     ]
    //   : []),
    // ...(AccessData &&
    //   Array.isArray(AccessData) &&
    //   AccessData.some((item) => item.module === "onsite")
    //   ? [
    //     {
    //       type: "collapse",
    //       icon: <AirplanemodeActiveIcon />,
    //       name: "Onsite",
    //       key: "onsite",
    //       route: "/onsite",
    //       component: <OnsiteTabel />,
    //       noCollapse: true,
    //       protected: true,
    //       permissions: {
    //         authenticated: true,
    //         roles: ["all"],
    //       },
    //     },
    //   ]
    //   : []),
    {
      name: "noCollapse",
      key: "add-onsite",
      route: "/onsite/add-onsite",
      component: <OnsiteForm />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      name: "noCollapse",
      key: "edit-onsite",
      route: "/onsite/edit-onsite",
      component: <OnsiteForm />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      name: "noCollapse",
      key: "view-onsite",
      route: "/onsite/view-onsite",
      component: <OnsiteForm />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "onboarding-employee-details",
      route: "/permission/requestpermission",
      component: <Permission />,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },

    {
      type: "noCollapse",
      key: "onboarding-employee-details",
      route: "/permission/approve",
      component: <PermissionApproval />,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "performance-evaluation-details",
      route: "/performance-evaluation/performance-evaluation-details",
      component: <PerfomanceEvaluationForm />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },

    {
      type: "noCollapse",
      key: "form",
      route: "/leaveclarify/form",
      component: <AddLeavecalrificationForm />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },

    {
      type: "noCollapse",
      key: "congrats",
      route: "/course-assessment/congrats",
      component: <CongratsPage />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },

    {
      type: "noCollapse",
      key: "creation",
      route: "/assesment/creation",
      component: <AddAssessmentCreation />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },

    {
      type: "noCollapse",
      key: "creation",
      route: "/course-assessment/test",
      component: <AssessmentPage />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      type: "noCollapse",
      key: "add-courseMaterial",
      route: "/courseMaterial/add-courseMaterial",
      component: <UpdateCourseMaterial />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },

    {
      type: "noCollapse",
      key: "approval-add",
      route: "/approval/approval-add",
      component: <AddWorkflow />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
    {
      name: "Approval",
      key: "resignation-approval",
      route: "/resignation-list/resignation-approval",
      component: <ResignationApproval />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },

    ...(AccessData &&
    Array.isArray(AccessData) &&
    AccessData.some((item) => true)
      ? [
          {
            type: "collapse",
            name: "Resignation ",
            key: "resignation ",
            icon: <Logout size="12px" />,
            collapse: [
              ...(AccessData && Array.isArray(AccessData)
                ? [
                    {
                      name: "Resignation List",
                      key: "resignation-list",
                      route: "/resignation-list",
                      component: <ResignationTabel />,
                    },
                  ]
                : []),
              ...(AccessData && Array.isArray(AccessData)
                ? [
                    {
                      name: "Resignation Form",
                      key: "resignation-form",
                      route: "/resignation-form",
                      component: <ResignationForm />,
                    },
                  ]
                : []),
              ...(AccessData && Array.isArray(AccessData)
                ? [
                    {
                      name: "Exit Form List",
                      key: "exit-form",
                      route: "/exit-form",
                      component: <ExitFormList />,
                    },
                    {
                      name: "Add-exit-form",
                      key: "add-exit-form",
                      route: "/exit-form/add-exit-form",
                      component: <AddExitForm />,
                    },
                  ]
                : []),
            ],
          },
        ]
      : []),

    {
      type: "collapse",
      icon: <PolicyIcon />,
      name: "Policy Management",
      key: "policy-management",
      route: "/policy-management",
      component: <PolicyManagementList />,
      noCollapse: true,
      protected: true,
      permissions: {
        authenticated: true,
        roles: ["all"],
      },
    },
  ];

  useEffect(() => {
    if (AccessData) {
      setroutesdata(routes);
    }
  }, [AccessData, setroutesdata]);
  return <div></div>;
}

export default Routes_Data;
